import React, { useState } from "react";
import { useQuery } from "react-query";
import { getVideoDetails } from "../../../api/functions/video.api";
import styles from "../../../styles/components/watchVideoModal.module.scss";
import { Box, Dialog } from "@mui/material";
import ApiLoader from "../../Loaders/ApiLoader";
import {
  concatHostAndVideoPath,
  roleFinderTwo,
} from "../../../lib/functions/utils.lib";

import HlsPalyer from "../components/HlsPlayer";
import { getCookie } from "../../../lib/functions/storage.lib";

const WatchVideoModal = ({ open, onClose, id }) => {
  const userCookie = getCookie("userdetails");
  let user = JSON.parse(userCookie ? userCookie : "{}");
  // const { data, isLoading: isLoadingGet } = useQuery(
  //   ["see_video", id],
  //   async () => getVideoDetails(id, roleFinderTwo(user.role_id)),
  //   {
  //     enabled: id && open ? true : false,
  //     onError: (err) => console.log("err", err),
  //   }
  // );
  console.log("id", id);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        sx={{
          "& .MuiDialog-container": {
            alignItems: "flex-start",
          },
        }}
        PaperProps={{
          sx: {
            alignItems: "flex-start",
            marginTop: "177px",
            width: "100%",
            maxWidth: "750px",
          },
        }}
      >
        {/* <ApiLoader loading={isLoadingGet} /> */}
        {/* {data && data.converted_url && (
          <> */}
        <Box className={styles.watchVideoWrapper}>
          <Box className={styles.watchVideo}>
            <HlsPalyer
              // source={concatHostAndVideoPath(data.converted_url)}
              source={id}
            />
          </Box>
        </Box>
        {/* </>
        )} */}
      </Dialog>
    </>
  );
};

export default WatchVideoModal;
